import type { ChatUiMobilityOffer } from '@voll-intelligence/genui-contract';

import executive2x from './assets/executive-2x.webp';
import executive3x from './assets/executive-3x.webp';
import taxi2x from './assets/taxi-2x.webp';
import taxi3x from './assets/taxi-3x.webp';

/** Uma ilustração do carro: o `src` (a @2x, que também serve de fallback) e o `srcSet`
 *  @2x/@3x para a tela escolher pela densidade. */
type RideArt = { readonly src: string; readonly srcSet: string };

const art = (x2: string, x3: string): RideArt => ({ src: x2, srcSet: `${x2} 2x, ${x3} 3x` });

/**
 * O carro da categoria de cada seção das ofertas de corrida (#6323, direção A aprovada pelo
 * design): o táxi na corrida da cooperativa e o sedã executivo no carro com motorista. É o
 * `section` do contrato que escolhe — não há campo de categoria no payload.
 *
 * Os renders são os «Modais 3D 2026» (Taxi e Luxo, Size=Large 80×46) da biblioteca do design.
 * No Figma cada variante é um recorte de um sprite único com fundo quase branco opaco; aqui o
 * arquivo é esse recorte, tirado do raw em alta (891×509 por carro) e reduzido a @2x/@3x, com o
 * fundo removido e a sombra de contato mantida como preto translúcido — opaco, o retângulo
 * claro aparecia sobre o `--sand-25` do hover da linha. WebP q92: ~5–12 KB por arquivo.
 *
 * O tamanho Small (63×36) do mobile é o mesmo recorte reduzido, então a linha estreita usa
 * estes arquivos em 63×36 em vez de baixar um segundo par. Importados (e não por URL) para o
 * bundler carimbar o hash junto com o resto — o kit não conhece a base de assets do host.
 */
export const RIDE_ART: Readonly<Record<ChatUiMobilityOffer['section'], RideArt>> = {
  cooperative: art(taxi2x, taxi3x),
  car_driver: art(executive2x, executive3x),
};
